<template>
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    {{ $t('delivery.label.outbound')}} <small class="text-muted">{{ $t('delivery.label.orders')}}</small>
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">
                  <header-button></header-button>
              </div><!--col-->
          </div><!--row-->
          <hr />
          <div class="row mt-4">
            <div class="col-sm-6">
              <h5 class="mb-3">{{ $t('delivery.label.filter_option') }}</h5>
              <b-form v-if="show">
                <div class="form-group row">
                  <label for="" class="col-sm-3 col-form-label">{{ $t('delivery.label.batch_id') }}</label>
                  <div class="col-sm-3 form-row">
                    <b-form-input type="number" v-model="filter.batchId" :placeholder="$t('delivery.label.enter_batch_id')"></b-form-input>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-3 col-form-label">{{ $t('delivery.label.upload_order_date') }}</label>
                  <div class="col-sm-9 row">
                    <div class="col-sm-6 form-row">
                      <datepicker v-model="filter.uploadDateFrom" :format="customFormatter" input-class="form-control"></datepicker>
                    </div>
                    <div class="col-sm-6 form-row">
                      <datepicker v-model="filter.uploadDateTo" :format="customFormatter" input-class="form-control"></datepicker>
                    </div>
                  </div>
                </div>
                <b-form-fieldset
                  :label="$t('delivery.label.reference_no')"
                  :description="$t('delivery.label.please_enter_reference_no')"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input type="text" v-model="filter.referenceNo" :placeholder="$t('delivery.label.enter_reference_no')"></b-form-input>
                </b-form-fieldset>
                <b-form-fieldset
                  :label="$t('delivery.label.waybill_number')"
                  :description="$t('delivery.label.please_enter_waybill_number')"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input type="text" v-model="filter.waybillNumber" :placeholder="$t('delivery.label.enter_waybill_number')"></b-form-input>
                </b-form-fieldset>
                <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('delivery.label.search') }}</b-button>
                <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('delivery.label.reset') }}</b-button>
              </b-form>
            </div><!--col-->
          </div>
          <div class="row mt-2">
            <div class="col-sm-12 col-md-5">
              <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
            </div>
          </div>
          <div class="row mt-2">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="7%">
                          <col width="7%">
                          <col width="7%">
                          <col width="7%">
                          <col width="7%">
                          <col width="7%">
                          <col width="7%">
                          <col width="7%">
                          <col width="7%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>{{ $t('delivery.label.batch_id') }}</th>
                            <th>{{ $t('delivery.label.reference_no') }}</th>
                            <th>{{ $t('delivery.label.waybill_number') }}</th>
                            <th>{{ $t('delivery.label.tracking_no') }}</th>
                            <th>{{ $t('delivery.label.ship_date') }}</th>
                            <th>{{ $t('delivery.label.weight') }}</th>
                            <th>{{ $t('delivery.label.delivery_name') }}</th>
                            <th>{{ $t('delivery.label.pieces') }}</th>
                            <th>{{ $t('delivery.label.declared_value') }}</th>
                            <th>{{ $t('delivery.label.status') }}</th>
                            <th>{{ $t('delivery.label.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(deliveryOrder, index) in deliveryOrders" :key="index">
                            <td>{{ deliveryOrder.batch_request_id }}</td>
                            <td>{{ deliveryOrder.reference_no }}</td>
                            <td>{{ deliveryOrder.waybill_number }}</td>
                            <td>{{ deliveryOrder.tracking_no }}</td>
                            <td>{{ deliveryOrder.ship_date }}</td>
                            <td>{{ deliveryOrder.weight }}</td>
                            <td>{{ deliveryOrder.delivery_name }}</td>
                            <td>{{ deliveryOrder.number_of_pieces }}</td>
                            <td>{{ deliveryOrder.declared_value }}</td>
                            <td v-html="deliveryOrder.status_label"></td>
                            <td>
                              <router-link :to="{ path: '/delivery/order/' + deliveryOrder.id }">
                                <b-button variant="info ml-1" size="sm"><i class="fa fa-search"></i></b-button>
                              </router-link>
                              <b-button size="sm" v-if="deliveryOrder.waybill_label_status == 1" variant="success ml-1" @click.stop.prevent="downloadLabel(deliveryOrder.reference_no)"><i class="fa fa-print"></i></b-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="row">
                        <div class="col-sm-12 col-md-5">
                          <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                          <nav>
                            <b-pagination align="end" :total-rows="this.meta.total" :per-page="this.meta.per_page" v-model="currentPage" :prev-text="$t('general.list.prev')" :next-text="$t('general.list.next')" @change='changePage' hide-goto-end-buttons/>
                          </nav>
                        </div>
                      </div>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
</template>

<script>
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import HeaderButton from '@/views/components/delivery/pending/HeaderButton'

export default {
  name: 'DelieryOrders',
  components: {
    HeaderButton,
    datepicker
  },
  mounted () {
    this.axios.get('/delivery/order/out-warehouse').then(response => {
      this.deliveryOrders = response.data
      this.meta = response.meta
      var vm = this
      response.data.forEach(function (deliveryOrder) {
        vm.referenceNos.push(deliveryOrder.reference_no)
      })
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      deliveryOrders: [],
      meta: [],
      referenceNos: [],
      selectedIds: [],
      allSelected: false,
      indeterminate: false,
      filter: {
        batchId: null,
        uploadDateFrom: '',
        uploadDateTo: '',
        referenceNo: '',
        waybillNumber: '',
      },
      currentPage: 1,
      show: true,
      batchIdOptions: {}
    }
  },
  watch: {
    selectedIds (newVal) {
      // Handle changes in individual flavour checkboxes
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.referenceNos.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },
  methods: {
    onReset () {
      // evt.preventDefault()
      this.filter.batchId = ''
      this.filter.referenceNo = ''
      this.filter.waybillNumber = ''
      this.filter.uploadDateFrom = moment().format('YYYY-MM-DD')
      this.filter.uploadDateTo = moment().add(1, 'day').format('YYYY-MM-DD')
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    toggleAll (checked) {
      this.selectedIds = checked ? this.referenceNos.slice() : []
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    downloadLabel (referenceNo) {
      this.axios.get('/delivery/download/order/' + referenceNo + '/label', {
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = referenceNo + '.pdf'
        link.click()
      }).catch(error => {
        console.log(error)
      })
    },
    onSearchForm () {
      this.axios.get('/delivery/order/out-warehouse', {
        params: {
          batch_id: this.filter.batchId,
          reference_no: this.filter.referenceNo,
          waybill_number: this.filter.waybillNumber,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo,
        }
      }).then(response => {
        this.deliveryOrders = response.data
        this.meta = response.meta
        var vm = this
        response.data.forEach(function (deliveryOrder) {
          vm.referenceNos.push(deliveryOrder.id)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    changePage (pageNum) {
      this.axios.get('/delivery/order/out-warehouse', {
        params: {
          batch_id: this.filter.batchId,
          reference_no: this.filter.referenceNo,
          waybill_number: this.filter.waybillNumber,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo,
          page: pageNum
        }
      }).then(response => {
        this.deliveryOrders = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
